
@if (isOpen()) {
  <div (click)="onBackdropClick($event)" class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 animate-fade-in-fast">
    <div class="bg-white rounded-lg shadow-xl w-full max-w-lg p-6 text-slate-800 m-4 max-h-[90vh] overflow-y-auto">
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-2xl font-bold">{{ 'modals.userForm.titleEdit' | translate }}</h2>
        <button (click)="onClose()" class="text-gray-400 hover:text-gray-600" title="Close modal">
          <i class="fa-solid fa-times text-xl"></i>
        </button>
      </div>
      
      <form [formGroup]="userForm" (ngSubmit)="onSave()">
        <div class="space-y-4">
          
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label for="name" class="block text-sm font-medium text-gray-700">{{ 'modals.userForm.name' | translate }}</label>
              <input id="name" type="text" formControlName="name" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm">
            </div>
             <div>
              <label for="email" class="block text-sm font-medium text-gray-700">{{ 'modals.userForm.email' | translate }}</label>
              <input id="email" type="email" formControlName="email" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 bg-gray-100 text-gray-500 sm:text-sm cursor-not-allowed">
            </div>
          </div>
          
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label for="role" class="block text-sm font-medium text-gray-700">{{ 'modals.userForm.role' | translate }}</label>
              <select id="role" formControlName="role" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm disabled:bg-gray-100 disabled:cursor-not-allowed">
                @for(role of userRoles; track role) {
                  <option [value]="role">{{ role }}</option>
                }
              </select>
            </div>
            <div>
              <label for="status" class="block text-sm font-medium text-gray-700">{{ 'modals.userForm.status' | translate }}</label>
               <select id="status" formControlName="status" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm">
                @for(status of userStatuses; track status) {
                  <option [value]="status">{{ status }}</option>
                }
              </select>
            </div>
          </div>

          <div>
            <label for="pin" class="block text-sm font-medium text-gray-700">{{ 'modals.userForm.pin' | translate }}</label>
            <input id="pin" type="text" formControlName="pin" [placeholder]="'modals.userForm.pinPlaceholder' | translate" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm font-mono" maxlength="6">
            @if(userForm.get('pin')?.hasError('pattern') || userForm.get('pin')?.hasError('minlength') || userForm.get('pin')?.hasError('maxlength')) {
                <p class="text-red-600 text-xs mt-1">PIN must be exactly 6 digits.</p>
            }
          </div>

          <!-- Doctor Signature Section -->
          @if(isDoctor) {
            <div class="border-t border-slate-200 pt-4 mt-4">
                <label class="block text-sm font-bold text-gray-700 mb-2">
                    <i class="fa-solid fa-file-signature text-blue-600"></i> Digital Signature (ลายเซ็นแพทย์)
                </label>
                
                <div class="bg-slate-50 p-4 rounded-lg border border-slate-200">
                    <div class="flex flex-col gap-4">
                        <!-- Current Signature -->
                        @if(signaturePreview) {
                            <div class="text-center">
                                <p class="text-xs text-gray-500 mb-1">Current Signature</p>
                                <img [src]="signaturePreview" class="h-20 mx-auto border bg-white p-2 rounded">
                            </div>
                        }

                        <!-- Signature Pad -->
                        <div>
                            <p class="text-xs text-gray-600 mb-1">Draw New Signature:</p>
                            <div class="border border-slate-300 bg-white rounded relative">
                                <canvas #signaturePad width="400" height="150" class="w-full h-[150px] cursor-crosshair touch-none"></canvas>
                                <button type="button" (click)="clearSignature()" class="absolute top-2 right-2 text-xs text-red-500 hover:text-red-700 bg-white/80 px-2 rounded">Clear</button>
                            </div>
                            <div class="flex justify-between items-center mt-2">
                                <label class="text-xs text-blue-600 cursor-pointer hover:underline">
                                    Upload Image instead
                                    <input type="file" (change)="onFileSelected($event)" accept="image/*" class="hidden">
                                </label>
                                <button type="button" (click)="saveSignatureFromPad()" class="bg-blue-600 text-white px-3 py-1 rounded text-xs font-bold hover:bg-blue-700">Save Signature</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          }

        </div>

        <div class="mt-8 flex justify-end space-x-3">
          <button type="button" (click)="onClose()" class="bg-gray-200 text-gray-800 px-4 py-2 rounded-md hover:bg-gray-300 font-semibold transition-colors">{{ 'modals.productForm.cancel' | translate }}</button>
          <button type="submit" [disabled]="userForm.invalid" class="bg-emerald-600 text-white px-4 py-2 rounded-md hover:bg-emerald-700 disabled:bg-emerald-300 font-semibold transition-colors">{{ 'modals.userForm.save' | translate }}</button>
        </div>
      </form>
    </div>
  </div>
}
